export const CardProductCode : {[x: string]: number} = Object.freeze({
    DreamCard       : 100921,
    PremierCard     : 100922,
    DirectCard      : 101007,
    WelcomeCard     : 103079,
    QuickCard       : 104560,
    MultiCurrency   : 101676,
    FamilyBlue      : 101687,
    FamilyPurple    : 101688
})

/**
 * 신규 네이티브 주소화면(브릿지 openReact_Web)이 도입된 최소 앱버전. (가정값 — 앱팀 확정 후 교체)
 * CardReceiveMethodSelect.clickNext 에서 분기:
 * - apiVersion >= 이 값  → 신규: CardReceiveMethodSelect 가 직접 openReact_Web("card/address") 호출 (별도 화면 없음)
 * - apiVersion <  이 값  → 기존: /apply/step6 원본 CardDeliverySelect
 */
export const NEW_ADDRESS_SCREEN_MIN_VERSION = 1250;

export const CardProductCodeName : {[x: number]: string} = Object.freeze({
    100921  : "Dream Card",
    100922  : "Premier Card",
    101007  : "Direct Card",
    103079  : "Welcome Card",
    104560  : "Quick Card",
    101676  : "Multi Currency",
    101687  : "FAMILY BLUE",
    101688  : "FAMILY PURPLE"
});

export const CardProductTabName : {[x: number]: string} = Object.freeze({
    100921  : "Dream",
    100922  : "Premier",
    101007  : "Direct",
    103079  : "Welcome",
    104560  : "Quick",
    101676  : "Multi",
    101687  : "BLUE",
    101688  : "PURPLE"
});

export const QUICK_CARD_REGISTER_MIN_VERSION = 795;